<app-traitement-data titre="Arrêt tabac" [sousTitre]="patient!.tableauDeBord?.arretTabac?.date | aLaDateDu"
    [statut]="patient!.tableauDeBord?.arretTabac | arretTabacStatut">
    {{ patient!.tableauDeBord?.arretTabac?.value ?? 'Pas de donnée' }}
</app-traitement-data>